import Helpers from "../helpers/utility";
export default Helpers.clone;
//# sourceMappingURL=clone.js.map